/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/index',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: '首页',
      keepAlive: false
    },
  },
  {
    path: '/detail',
    component: () => import('@/views/home/detail.vue'),
    meta: {
      title: '详情页',
      keepAlive: false
    },
  },
  {
    path: '/history',
    component: () => import('@/views/home/history.vue'),
    meta: {
      title: '历史',
      keepAlive: false
    },
  },
]
